import { render, staticRenderFns } from "./UserPolices.vue?vue&type=template&id=1f349847"
import script from "./UserPolices.vue?vue&type=script&lang=js"
export * from "./UserPolices.vue?vue&type=script&lang=js"
import style0 from "./UserPolices.vue?vue&type=style&index=0&id=1f349847&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports